import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from '../event-emitter.service';
import { ActivatedRoute, Router} from '@angular/router';
// 1
import { TotemService } from '../totem.service';

@Component({
  selector: 'app-new-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.css']
})
export class NewFooterComponent implements OnInit {

  
  estadoFooter = true;
  // 2
  public actual: string = '';
  constructor(private eventEmitterService: EventEmitterService, private router: Router,
              private route: ActivatedRoute, public totemService: TotemService) {
    router.events.subscribe((val) => {
      this.comprobarPath();
    });
    // 3
    this.actual = this.totemService.actualLanguage;
   }

  // ngOnInit() {
  //   if (this.eventEmitterService.subsVar === undefined) {
  //     this.eventEmitterService.subsVar = this.eventEmitterService.
  //     invokeExampleComponentFunction.subscribe((name: string) => {
  //       console.log('llamado header foter');
  //       if (name === 'show') {
  //         this.mostrarHeader();
  //       } else if (name === 'hide') {
  //         this.ocultarHeader();
  //       }
  //       console.log('[HEADER]', name);
  //     });
  //   }
  // }
  ngOnInit() {
    if (this.eventEmitterService.subsVar === undefined) {
      this.eventEmitterService.subsVar = this.eventEmitterService.
      invokeHeaderComponentFunction.subscribe((name: string) => {
        console.log('llamado header foter');
        if (name === 'show') {
          this.mostrarHeader();
        } else if (name === 'hide') {
          this.ocultarHeader();
        }
        // console.log('[HEADER]', name);
      });
    }
  }
  comprobarPath() {
    const tipoRuta = this.router.url.split('/')[1];
    this.estadoFooter = tipoRuta === 'mapa-new' || tipoRuta === 'mapa' ? false : true;
  }

  ocultarHeader() {
    this.estadoFooter = false;
  }
  mostrarHeader() {
    this.estadoFooter = true;
  }

  // 4
  changeLanguage(language: any) {
    this.actual = language;
    this.totemService.changeLanguage(language);
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }
}
